import React from "react";
import { useQuery } from "react-query";
import Advertisement from "./Advertisement";
import hero from "../../../assets/slider/hero.jpg";
import suzuki from "../../../assets/slider/suzuki.jpg";

const Advertisements = () => {
  // const url = "https://bike-resell-server-hasanalibd.vercel.app/getbikes";
  const url =
    "https://bike-resell-server-hasanalibd.vercel.app/advertise/public";
  const { data: bikes = [], refetch } = useQuery({
    queryKey: ["advertise"],
    queryFn: async () => {
      const res = await fetch(url);
      const data = await res.json();
      return data;
    },
  });

  console.log(bikes);
  return (
    <div>
      <h1 className="text-3xl font-bold text-center mt-5 text-[#149777]">
        Advertise
      </h1>

      {bikes.map((bike) => (
        <Advertisement key={bike._id} bike={bike}></Advertisement>
      ))}

      <div className="card card-side bg-base-100 gap-5 my-4 py-4  shadow-xl flex lg:w-2/3 w-full mx-auto  items-center">
        <figure>
          <img className="w-64 p-5 lg:mx-10" src={suzuki} alt="Movie" />
        </figure>
        <div className="">
          <h2 className="text-2xl font-semibold">Suzuki Gixxer</h2>
          <p className="text-xl my-2">14800km, 180cc</p>
          <p className="text-xl my-2">Hatiya, Noakhali, Chittagong</p>
          <h1 className="text-2xl font-semibold text-[#149777]">
            Price: 175000 Tk
          </h1>
        </div>
      </div>

      <div className="card card-side bg-base-100 gap-5 my-4 py-4  shadow-xl flex lg:w-2/3 w-full mx-auto  items-center">
        <figure>
          <img className="w-64 p-5 lg:mx-10" src={hero} alt="Movie" />
        </figure>
        <div className="">
          <h2 className="text-2xl font-semibold">Honda CBR 1000RR SP</h2>
          <p className="text-xl my-2">14800km, 180cc</p>
          <p className="text-xl my-2">Maijdee, Noakhali, Chittagong</p>
          <h1 className="text-2xl font-semibold text-[#149777]">
            Price: 355000 Tk
          </h1>
        </div>
      </div>
    </div>
  );
};

export default Advertisements;
